import * as types from './constants';

export const getModulesConfiguration = () => ({
    types: [
        types.GET_MODULES_CONFIGURATION_REQUEST,
        types.GET_MODULES_CONFIGURATION_SUCCESS,
        types.GET_MODULES_CONFIGURATION_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/modules/ukrposhta/config`,
            method: 'GET',
        }),
});

export const updateModuleConfiguration = (config) => ({
    types: [
        types.UPDATE_MODULES_CONFIGURATION_REQUEST,
        types.UPDATE_MODULES_CONFIGURATION_SUCCESS,
        types.UPDATE_MODULES_CONFIGURATION_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/modules/ukrposhta/config`,
            method: 'POST',
            body: config
        }),
});

export const createClient = (config) => ({
    types: [
        types.CREATE_CLIENT_REQUEST,
        types.CREATE_CLIENT_SUCCESS,
        types.CREATE_CLIENT_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/modules/ukrposhta/config/client`,
            method: 'POST',
            body: config
        }),
});

export const deleteClient = (client_id) => ({
    types: [
        types.DELETE_CLIENT_REQUEST,
        types.DELETE_CLIENT_SUCCESS,
        types.DELETE_CLIENT_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/modules/ukrposhta/config/client/${client_id}`,
            method: 'DELETE',
        }),
});

export const getClients = () => ({
  types: [
    types.GET_CLIENTS_REQUEST,
    types.GET_CLIENTS_SUCCESS,
    types.GET_CLIENTS_FAILURE,
  ],
  promise: api =>
    api({
      url: `/api/v1/modules/ukrposhta/clients`,
      method: 'GET',
    }),
});

export const getCities = (query) => ({
  types: [
    types.GET_CITIES_REQUEST,
    types.GET_CITIES_SUCCESS,
    types.GET_CITIES_FAILURE,
  ],
  promise: api =>
    api({
      url: `/api/v1/modules/ukrposhta/address/city?query=${query}`,
      method: 'GET',
    }),
});

export const createTTN = (order_id, payload) => ({
  types: [
    types.CREATE_TTN_REQUEST,
    types.CREATE_TTN_SUCCESS,
    types.CREATE_TTN_FAILURE,
  ],
  promise: api =>
    api({
      url: `/api/v1/modules/ukrposhta/ttn?order_id=${order_id}`,
      method: 'POST',
      body: payload
    }),
});

export const getTtnMarking = (order_id, size) => ({
  types: [
    types.GET_TTN_MARKING_REQUEST,
    types.GET_TTN_MARKING_SUCCESS,
    types.GET_TTN_MARKING_FAILURE,
  ],
  promise: api =>
    api({
      url: `/api/v1/modules/ukrposhta/marking/${order_id}/${size}`,
      method: 'GET',
      responseType: "blob",
    }),
});
